import { render, staticRenderFns } from "./videoContent.vue?vue&type=template&id=3be4525a&scoped=true&"
import script from "./videoContent.vue?vue&type=script&lang=js&"
export * from "./videoContent.vue?vue&type=script&lang=js&"
import style0 from "./videoContent.vue?vue&type=style&index=0&id=3be4525a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4525a",
  null
  
)

export default component.exports